/**
 * Constants for Circular Tunnel
 * Centralized configuration values
 */

export const MULTIPLIER = 5;
export const PADDING = 110;
export const POINTS_OFFSET = 60;
export const SCALE_INTERVAL = 10; // meters
export const MINOR_SCALE_INTERVAL = 1; // meters
export const CIRCLE_RADIUS = 2; // for P6 point visualization
export const MIN_RADIUS = 2;
export const MAX_RADIUS = 40;
export const MIN_DIRECTION = 0;
export const MAX_DIRECTION = 360;
export const MIN_DIP_AMOUNT = 0;
export const MAX_DIP_AMOUNT = 90;
export const TOAST_AUTO_DISMISS_TIMEOUT = 5000;
